import MigrationMessagingBanner from 'ui-addon-conversations-settings/help-desk-migration/components/MigrationMessagingBanner';
import { useConnectedEmailAccountByChannelInstanceId } from 'ui-addon-conversations-settings/help-desk-migration/hooks/useConnectedEmailAccount';
import { getEmailOrFormMigrationStatusUrl } from '../../../urls/getHelpDeskMigrationUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailMigrationBanner = ({
  channel,
  inboxId
}) => {
  const {
    channelInstanceId
  } = channel;
  const {
    connectedEmailAccount
  } = useConnectedEmailAccountByChannelInstanceId(channelInstanceId);
  if (!connectedEmailAccount) {
    return null;
  }
  return /*#__PURE__*/_jsx(MigrationMessagingBanner, {
    channel: channel,
    viewStatusRoute: getEmailOrFormMigrationStatusUrl(inboxId, 'email', connectedEmailAccount.id)
  });
};
EmailMigrationBanner.displayName = 'EmailMigrationBanner';
export default EmailMigrationBanner;